import { render, staticRenderFns } from "./RingLoader.vue?vue&type=template&id=1af5b628&scoped=true&"
import script from "./RingLoader.vue?vue&type=script&lang=js&"
export * from "./RingLoader.vue?vue&type=script&lang=js&"
import style0 from "./RingLoader.vue?vue&type=style&index=0&id=1af5b628&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af5b628",
  null
  
)

export default component.exports